<div class="kt-portlet" [ngClass]="class" #refPortlet>
	<ng-content></ng-content>
</div>
